import React from "react";

const Budu = (props) => (
  <svg
    width="90"
    height="24"
    viewBox="0 0 90 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M85.636 0L79.5881 10.3605L71.5761 0H66.7751L77.4994 13.8751L72.8231 21.8824H77.1876L90.0005 0H85.636Z"
      fill="black"
    />
    <path
      d="M40.0143 0L34.1554 10.3605L26.4241 0H21.7731L32.1622 13.8751L27.6019 21.8824H31.8602L44.2726 0H40.0143Z"
      fill="black"
    />
    <path
      d="M64.0702 0H47.8435V12.317C47.8435 14.7623 47.0781 18.0226 44.3839 18.0226H42.8224V24H46.5882V21.6453H63.7334V24H67.4992V18.0226H64.0396V0H64.0702ZM60.3043 3.62264V18.0226H50.201C51.5175 16.1208 51.6094 14.0981 51.6094 12.317V3.62264H60.3043Z"
      fill="black"
    />
    <path
      d="M12.3495 8.34341H3.84556V3.63687H19.1965V0H0V21.8824H12.8498C15.1322 21.8824 16.8205 21.2099 18.1961 19.9264C19.603 18.6122 20.3221 17.023 20.3221 15.1281C20.3221 13.2639 19.6343 11.6746 18.2274 10.3605C16.8205 9.01578 15.3197 8.34341 12.3495 8.34341ZM16.4453 15.0976C16.4453 15.9533 16.1013 16.7174 15.4448 17.298C14.7882 17.9093 14.1004 18.215 12.8186 18.215H3.84556V11.9803H12.8498C14.0379 11.9803 14.8508 12.2859 15.5073 12.8972C16.1326 13.5389 16.4453 14.2419 16.4453 15.0976Z"
      fill="black"
    />
  </svg>
);

export default Budu;
